import { useSelect } from "downshift";
import {
  CheckIcon,
  ChevronPaginationDownIcon,
  ChevronUp,
} from "src/assets/icons";
import {
  Container,
  HeaderContainer,
  List,
  ListItem,
} from "./PageSizeDropdown.styles";
import { GhostButton } from "src/components/Buttons";

interface PageSizeDropdownProps {
  pageSize: number;
  setPageSize: (pageSize: number) => void;
}

export default ({ pageSize, setPageSize }: PageSizeDropdownProps) => {
  const pageSizeChoices = [10, 25, 50, 100];
  const { isOpen, getToggleButtonProps, getMenuProps, getItemProps } =
    useSelect({
      items: pageSizeChoices,
      selectedItem: pageSize,
      onSelectedItemChange: ({ selectedItem: newPageSize }) =>
        setPageSize(newPageSize ?? 10),
    });

  return (
    <Container>
      <HeaderContainer>
        <GhostButton {...getToggleButtonProps()}>
          <span>{pageSize}</span>
          {isOpen ? <ChevronUp /> : <ChevronPaginationDownIcon />}
        </GhostButton>
      </HeaderContainer>
      <List {...getMenuProps()} style={{ display: isOpen ? "block" : "none" }}>
        {isOpen &&
          pageSizeChoices.map((item, index) => (
            <ListItem key={item} {...getItemProps({ item, index })}>
              {item}
              {pageSize === item && <CheckIcon />}
            </ListItem>
          ))}
      </List>
    </Container>
  );
};
